import React, { useEffect, useState } from "react";
import { makeStyles, Grid } from "@material-ui/core";

import { TextButton, TextInput, DropdownInput } from "../../../../../components/base";
import { COLORS } from "../../../../../theme/colors";
import { ChangePasswordModal } from "../../../../../components/modals/ChangePasswordModal";
import { SuccessModal } from "../../../../resetPassword/SuccessModal";
import { UNIT_SYSTEM } from "../../sample";
import endPoints from "../../../../../services/apiEndPoints";
import { getData } from "../../../../../services";

export const useStyles = makeStyles((theme) => ({
  labelRoot: {
    color: theme.palette.grey["500"],
  },
  inputRootStyle: {
    color: COLORS.darks[0][100],
    padding: theme.spacing(1.5),
  },
}));

const USER_ROLE = {
  SUPER_PM: "Supervisor PRaaS Manager",
  MANAGER: "PRaaS Manager",
  OPERATOR: "Building Operator",
};

const ProfileDetails = ({ user, errors, setUserName, setErrors, updateInfo }) => {
  const classes = useStyles();
  const [isopen, setOpen] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [currencies, setCurrencies] = useState();

  useEffect(() => {
    getData(endPoints.CURRENCIES, (data) => {
      setCurrencies(data);
    }).catch((error) => {
      console.error("Error fetching currencies:", error);
    });
  }, []);

  return (
    <Grid item xs={12}>
      <TextInput
        id="email-input"
        fullWidth
        label="Email"
        value={user.email}
        error={errors.email}
        labelRoot={classes.labelRoot}
        inputRootStyle={classes.inputRootStyle}
        style={{ backgroundColor: COLORS.darks[0][10] }}
        disabled
      />
      <TextInput
        id="email-input"
        fullWidth
        label="Your Name"
        placeHolder="your name"
        rootStyle={classes.input}
        onChange={(v) => setUserName(v)}
        error={errors.userName}
        value={user.username}
        onFocus={() => setErrors({ ...errors, userName: null })}
        onBlur={() => {
          updateInfo();
        }}
        labelRoot={classes.labelRoot}
      />
      <TextInput
        id="Role-input"
        fullWidth
        placeHolder="My Role"
        label="My Role"
        error={errors.role}
        defaultValue={USER_ROLE[user?.user_role]}
        style={{ backgroundColor: COLORS.darks[0][10] }}
        labelRoot={classes.labelRoot}
        disabled
      />
      <DropdownInput
        options={UNIT_SYSTEM}
        label="Unit System"
        setvalue={(v) => updateInfo("", v)}
        value={user.unit_system}
        defaultValue={user.unit_system}
        labelRoot={classes.labelRoot}
      />
      <DropdownInput
        label="Currency"
        labelField="code"
        valueField="id"
        options={currencies}
        setvalue={(selectedCurrency) => updateInfo("", "", selectedCurrency)}
        value={user.currency}
        defaultValue={user.currency}
        labelRoot={classes.labelRoot}
        style={{ marginTop: "12px" }}
      />
      <Grid style={{ marginTop: 30 }}>
        <TextButton text="Change password" onClick={() => setOpen(true)} />
      </Grid>

      <ChangePasswordModal
        isOpen={isopen}
        setOpen={setOpen}
        setShowSuccessModal={setShowSuccessModal}
      />
      {showSuccessModal && (
        <SuccessModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)} />
      )}
    </Grid>
  );
};

export default ProfileDetails;
